import PropTypes from 'prop-types';
// @mui
import { Box, Stack, Tooltip, Link } from '@mui/material';
//
import { getFormattedImageURL } from 'utils/helper';
import Image from 'components/image';
import DownloadButton from './DownloadButton';
import { fileData, fileFormat, fileThumb } from './utils';

// ----------------------------------------------------------------------

FileThumbnail.propTypes = {
  sx: PropTypes.object,
  imgSx: PropTypes.object,
  tooltip: PropTypes.bool,
  imageView: PropTypes.bool,
  onDownload: PropTypes.func,
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default function FileThumbnail({ file, tooltip, imageView, onDownload, sx, imgSx }) {
  const { name = '', path = '', preview = '' } = fileData(file);

  const format = fileFormat(path || preview);

  const renderContent =
    format === 'image' && imageView ? (
      <Box
        component="img"
        src={getFormattedImageURL(preview)}
        sx={{
          width: 1,
          height: 1,
          flexShrink: 0,
          objectFit: 'cover',
          ...imgSx,
        }}
      />
    ) : (
      <Link
      href={getFormattedImageURL(preview)}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      sx={{ width: '100%', height: '100%' }}
    >
      <Image
        alt="file preview"
        src={getFormattedImageURL(file)}
        sx={{
          top: 8,
          left: 8,
          // zIndex: 8,
          borderRadius: 1,
          position: 'absolute',
          width: 'calc(100% - 16px)',
          height: 'calc(100% - 16px)',
        }}
      /></Link>
      // <Box
      //   component="img"
      //   src={fileThumb(format)}
      //   sx={{
      //     width: 32,
      //     height: 32,
      //     flexShrink: 0,
      //     ...sx,
      //   }}
      // />
    );

  if (tooltip) {
    return (
      <Tooltip title={name}>
        <Stack
          flexShrink={0}
          component="span"
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 'fit-content',
            height: 'inherit',
          }}
        >
          {renderContent}
          {onDownload && <DownloadButton onDownload={onDownload} />}
        </Stack>
      </Tooltip>
    );
  }

  return (
    <>
      {renderContent}
      {onDownload && <DownloadButton onDownload={onDownload} />}
    </>
  );
}
